import React, { useState } from 'react';
import classNames from 'classnames/bind';
import { useNavigate } from 'react-router-dom';
import { Row, Button, Space } from 'antd';
import useMountEffect from '@restart/hooks/useMountEffect';
import commaNumber from 'comma-number';
import dayjs from 'dayjs';

import styles from './index.module.scss';
import { downloadExcelFile } from '../../utils/FileDownloader';
import { getDisplayName } from '../../utils/getDisplayName';
import API from '../../helpers/API';
import { UnitTable } from '../../components/ui';
import {
  buildLocationColumns,
  formatLocationAddress,
  LOCATION_TABLE_SCROLL_X,
} from './locationTable';

const cx = classNames.bind(styles);

const Page = () => {
  const navigate = useNavigate();
  const [locations, setLocations] = useState();

  useMountEffect(() => {
    // API: 거점 내역 조회
    API.get('/locations').then(({ success, data }) => {
      if (success) {
        setLocations(data.locations);
      }
    });
  });

  const moveToForm = () => {
    navigate('/locations/new');
  };

  const download = () => {
    const records = locations.map((location) => {
      return {
        A: location.name,
        B: formatLocationAddress(location),
        C: dayjs(location.createdAt).format('YYYY-MM-DD HH:mm:ss'),
        D: getDisplayName(location.createdBy),
        E: dayjs(location.updatedAt).format('YYYY-MM-DD HH:mm:ss'),
        F: getDisplayName(location.updatedBy),
      };
    });

    downloadExcelFile(
      [
        {
          A: '거점명',
          B: '주소',
          C: '등록일시',
          D: '등록자',
          E: '수정일시',
          F: '수정자',
        },
      ],
      records,
      `거점내역-${dayjs().format('YYYYMMDDHHmmss')}`,
    );
  };

  if (locations === undefined) return;

  return (
    <div className={cx('container')}>
      <h1 className={cx('title')}>거점 내역</h1>
      <Row align="middle" justify={'space-between'} className={cx('controlbar')}>
        <div className={cx('total')}>{locations && `총 ${commaNumber(locations.length)}`}건</div>
        <Space>
          <Button type="primary" onClick={download}>
            엑셀 다운로드
          </Button>
          <Button type="primary" onClick={moveToForm}>
            신규
          </Button>
        </Space>
      </Row>
      <UnitTable
        columns={buildLocationColumns()}
        dataSource={locations}
        rowKey={(record) => record.rid}
        virtual={false}
        sticky={true}
        scroll={{ x: LOCATION_TABLE_SCROLL_X }}
        onRow={(record) => ({
          onClick: () => navigate(`/locations/${record.rid}`),
        })}
      />
    </div>
  );
};

export default Page;
